import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import {displayText} from '../utils'

interface SubscriptionTypeToIconMap {
  [key: string]: string,
}

export class TypeCell extends GridCell {
  private typesToIcons: SubscriptionTypeToIconMap = {
    Content: 'fa fa-newspaper',
    Event: 'fa fa-calendar-alt',
    Instagram: 'fab fa-instagram',
    Job: 'fa fa-industry',
    Promotion: 'fa fa-gift',
    Survey: 'fa fa-poll',
    Text: 'fa fa-quote-right',
    Webinar: 'fa fa-volume-down',
  }

  public render() {

    return <td>
            <span>
              {this.props.dataItem.type.includes('Sponsored') ?
                <i className="fas fa-dollar-sign"></i>
              : null
              }
              &nbsp;
              {this.props.dataItem.type.includes(' ') ?
                <i className={this.typesToIcons[this.props.dataItem.type.split(' ')[1]]}></i>
              : <i className={this.typesToIcons[this.props.dataItem.type]}></i>
              }
              &nbsp;
              {displayText(this.props.dataItem.type)}
            </span>
          </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/render/type_cell.tsx